import { EmptyGuid } from '../emptyGuid';
import { luscinia } from '../luscinia';
import { BootgridState, BootgridViewType } from './ViewManager/viewManagerTypes';

export class BootgridSettings {
    bootgridState: BootgridState;

    viewType: BootgridViewType;
    allowMultiSelect: boolean;
    allowSelection: boolean;
    allowRowSelection: boolean;
    showCheckBox: boolean;
    showRefreshButton: boolean;
    showColumnSelection: boolean;
    showSearchInput: boolean;
    showFooterInfoBar: boolean;
    showHeaderInfoBar: boolean;
    showActionHeader: boolean;
    paging: boolean;
    editGrid: boolean;
    addColumnSearch: boolean;
    inlineEditable: boolean;
    columnSearchValues: object;

    allowNew: boolean;
    allowEdit: boolean;
    allowDelete: boolean;
    allowExport: boolean;

    buttonHeaderNew: string;
    buttonHeaderEdit: string;
    buttonHeaderDelete: string;
    
    permalink: string;
    recordView: string;

    inRecordView: boolean;
    buttonHeaderExport: string;
    customBtn: string;
    ajax: boolean;
    isParameterBootgrid: boolean;
    isRecordBootgrid: boolean;

    isRowEditButtonVisible: boolean;
    isRowDeleteButtonVisible: boolean;

    constructor(bootgrid: JQuery<HTMLElement>, config: Config) {
        const bootgridData = luscinia.bootgrid.data;
        const bootgridDefaults = luscinia.bootgrid.defaults;

        this.allowMultiSelect = bootgrid.data(bootgridData.multiSelection) === undefined ? bootgridDefaults.multiSelection : bootgrid.data(bootgridData.multiSelection);
        this.allowSelection = bootgrid.data(bootgridData.selection) === undefined ? bootgridDefaults.selection : bootgrid.data(bootgridData.selection);
        this.allowRowSelection = bootgrid.data(bootgridData.rowSelection) === undefined ? bootgridDefaults.rowSelection : bootgrid.data(bootgridData.rowSelection);
        this.showCheckBox = bootgrid.data(bootgridData.showCheckBox) === undefined ? bootgridDefaults.showCheckBox : bootgrid.data(bootgridData.showCheckBox);
        this.showRefreshButton = bootgrid.data(bootgridData.showRefreshButton) === undefined ? bootgridDefaults.showRefreshButton : bootgrid.data(bootgridData.showRefreshButton);
        this.showColumnSelection = bootgrid.data(bootgridData.showColumnSelection) === undefined ? bootgridDefaults.showColumnSelection : bootgrid.data(bootgridData.showColumnSelection);
        this.showSearchInput = bootgrid.data(bootgridData.showSearchInput) === undefined ? bootgridDefaults.showSearchInput : bootgrid.data(bootgridData.showSearchInput);
        this.showFooterInfoBar = bootgrid.data(bootgridData.showFooterInfoBar) === undefined ? bootgridDefaults.showFooterInfoBar : bootgrid.data(bootgridData.showFooterInfoBar);
        this.showHeaderInfoBar = bootgrid.data(bootgridData.showHeaderInfoBar) === undefined ? bootgridDefaults.showHeaderInfoBar : bootgrid.data(bootgridData.showHeaderInfoBar);
        this.showActionHeader = bootgrid.data(bootgridData.showActionHeader) === undefined ? bootgridDefaults.showActionHeader : bootgrid.data(bootgridData.showActionHeader);
        this.editGrid = bootgrid.data(bootgridData.editGrid) === undefined ? bootgridDefaults.editGrid : bootgrid.data(bootgridData.editGrid);
        this.addColumnSearch = bootgrid.data(bootgridData.addColumnSearch) === undefined ? bootgridDefaults.addColumnSearch : bootgrid.data(bootgridData.addColumnSearch);
        this.inlineEditable = bootgrid.data(bootgridData.inlineEditable) === undefined ? bootgridDefaults.inlineEditable : bootgrid.data(bootgridData.inlineEditable);
        this.columnSearchValues = bootgrid.data(bootgridData.columnSearchValues) === undefined ? bootgridDefaults.columnSearchValues : bootgrid.data(bootgridData.columnSearchValues);
        this.paging = bootgrid.data(bootgridData.paging) === undefined ? bootgridDefaults.paging : bootgrid.data(bootgridData.paging);
        this.ajax = bootgrid.data("ajax") === undefined ? bootgridDefaults.ajax : bootgrid.data("ajax");
        this.isParameterBootgrid = bootgrid.data("parameterbootgrid") === undefined ? false : bootgrid.data("parameterbootgrid");
        this.isRecordBootgrid = bootgrid.data("recordbootgrid") === undefined ? false : bootgrid.data("recordbootgrid");
        this.isRowDeleteButtonVisible = bootgrid.data(bootgridData.isRowDeleteButtonVisible) === undefined ? bootgridDefaults.isRowDeleteButtonVisible : bootgrid.data(bootgridData.isRowDeleteButtonVisible);
        this.isRowEditButtonVisible = bootgrid.data(bootgridData.isRowEditButtonVisible) === undefined ? bootgridDefaults.isRowEditButtonVisible : bootgrid.data(bootgridData.isRowEditButtonVisible);
        this.viewType = bootgrid.data(bootgridData.viewType);

        this.bootgridState = {
            BootgridId: '',
            SelectedGridViewId: '',
            IsAdvancedSearchCollapsed: bootgrid.data(bootgridData.isAdvancedSearchCollapsed) === undefined ? bootgridDefaults.isAdvancedSearchCollapsed : (bootgrid.data(bootgridData.isAdvancedSearchCollapsed) === 'true'),
            IsColumnSearchCollapsed: bootgrid.data(bootgridData.isColumnSearchCollapsed) === undefined ? bootgridDefaults.isColumnSearchCollapsed : bootgrid.data(bootgridData.isColumnSearchCollapsed) === 'true',
            RowDisplayCount: bootgrid.data(bootgridData.selectedRowCount) === undefined ? bootgridDefaults.selectedRowCount : parseInt(bootgrid.data(bootgridData.selectedRowCount)),
            SelectedSubTableId: bootgrid.data(bootgridData.selectedSubTableName) === undefined ? 'none' : bootgrid.data(bootgridData.selectedSubTableName),
            AdvancedFilters: [],
            ColumnSearches: [],
            SortColumn: {
                ColumnDataId: '',
                SortDirection: 'asc',
            },
            VisibleColumnIds: [],
            SelectedRowId: bootgrid.data(bootgridData.selectedRowId) === undefined ? null : bootgrid.data(bootgridData.selectedRowId),
            CurrentPage: bootgrid.data(bootgridData.selectedPageNumber) === undefined ? bootgridDefaults.selectedPageNumber : parseInt(bootgrid.data(bootgridData.selectedPageNumber)),
        }
        
        this.inRecordView = bootgrid.data(bootgridData.inRecordView)

        // get security attributes
        this.allowNew = bootgrid.data(bootgridData.allowNew) === undefined ? bootgridDefaults.allowNew : bootgrid.data(bootgridData.allowNew);
        this.allowEdit = bootgrid.data(bootgridData.allowEdit) === undefined ? bootgridDefaults.allowEdit : bootgrid.data(bootgridData.allowEdit);
        this.allowDelete = bootgrid.data(bootgridData.allowDelete) === undefined ? bootgridDefaults.allowDelete : bootgrid.data(bootgridData.allowDelete);
        this.allowExport = bootgrid.data(bootgridData.allowExport) === undefined ? bootgridDefaults.allowExport : bootgrid.data(bootgridData.allowExport);

        this.buttonHeaderExport = this.allowExport ? `<button type='button' data-${luscinia.data.action}='table-export' class='btn btn-default'><i class='fa fa-arrow-circle-down'> </i></button>` : '';
        // Set new, edit and delete buttons
        this.buttonHeaderNew = '';
        this.buttonHeaderEdit = '';
        this.buttonHeaderDelete = '';

        // Get record view attribute and set edit and new buttons accordingly
        this.permalink = bootgrid.data(bootgridData.permaLink);
        this.recordView = bootgrid.data(bootgridData.recordView) || '';

        if (this.editGrid) {
            if (this.recordView !== "") {
                this.recordView = `/${this.permalink}/${this.recordView}`;
                this.buttonHeaderNew = `<a class='btn btn-outline-secondary text-dark d-flex gap-1 align-items-center' href='${this.recordView}?action=new' ${this.allowNew ? luscinia.css.dataTableSelectionChanged : "disabled"} test-id='new-record'><i class='far fa-file'> </i><span class='hidden-sm hidden-xs'>${config.translations.captionActionNew}</span></a>`;
            } else {
                this.buttonHeaderNew = `<button type='button' data-${luscinia.data.action}='record-new' class='btn btn-outline-secondary text-dark d-flex gap-1 align-items-center' ${this.allowNew ? luscinia.css.dataTableSelectionChanged : "disabled"} test-id='new-record'><i class='far fa-file'> </i><span class='hidden-sm hidden-xs'>${config.translations.captionActionNew}</span></button>`;
                if (this.viewType !== BootgridViewType.Grid) {
                    this.buttonHeaderEdit = `<button type='button' data-${luscinia.data.action}='record-edit' class='btn btn-outline-secondary text-dark d-flex gap-1 align-items-center' ${this.allowEdit ? luscinia.css.dataTableSelectionChanged : "disabled"}><i class='fas fa-pencil-alt'></i><span class='hidden-sm hidden-xs'>${config.translations.captionActionEdit}</span></button>`;
                    this.buttonHeaderDelete = `<button type='button' data-${luscinia.data.action}='record-delete' class='btn btn-outline-secondary text-dark d-flex gap-1 align-items-center' ${this.allowDelete ? luscinia.css.dataTableSelectionChanged : "disabled"}><i class='fa fa-times-circle'> </i><span class='hidden-sm hidden-xs'>${config.translations.captionActionDelete}</span></button>`;
                }
            }
        }

        this.customBtn = bootgrid.data(bootgridData.customBtn) || '';

        this.setBootgridDataUrl(bootgrid);
    }

    private setBootgridDataUrl(bootgrid: JQuery<HTMLElement>) {
        if (this.inRecordView) {
            const rowId = luscinia.getQueryParameterByKey('id');
    
            var action = luscinia.getQueryParameterByKey('action');
            // If new record then do not allow any actions yet on sub tables
            if (action === 'new') {
                this.buttonHeaderNew = '';
                this.buttonHeaderEdit = '';
                this.buttonHeaderDelete = '';
                this.buttonHeaderExport = '';
            }
            var url = bootgrid.data(luscinia.data.modalUrl);
            if (url === undefined || url === '') {
                url = bootgrid.data(luscinia.data.baseUrl);
            }
            bootgrid.data('url', url + '/bootgrid/' + bootgrid.data(luscinia.data.filterColumnName) + '/' + (rowId || EmptyGuid.value));
        } else if (bootgrid.data(luscinia.data.filterColumnName) === '') {
            bootgrid.data('url', bootgrid.data(luscinia.data.baseUrl) + '/bootgrid');
        }
    }
}